export const AUTH_STORAGE_KEY = 'vunapay-auth';
